import React from "react";
import Banner from "./Banner";
import VideoForm from "./VideoForm";
import { Helmet } from "react-helmet";
import useWebsiteSetting, { useBannerdata, usePagemetaTags } from "../FetchAPI";

export default function Contact() {

  const [bannerdata] = useBannerdata();
  const [webSetting] = useWebsiteSetting();
  const [PagemetaTags] = usePagemetaTags();


  return (
    <>
      <Helmet>
        <title>{PagemetaTags.ContactMetatitle}</title>
        <meta name="keywords" content={PagemetaTags.ContactMetaKeyword} />
        <meta name="description" content={PagemetaTags.ContactMetaDesc} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>

      <Banner
        Bnanerimage={bannerdata.contact_banner}
        image_title={bannerdata.contact_banner_title}
        image_alt={bannerdata.contact_banner_alt}
      />
      <section className="contact_section section_padding">
        <div className="container">

          <div className="services-header text-center mb-5">
            <span className="services-badge">Contact us</span>
            <h2 className="services-title">Get In Touch</h2>

          </div>

          <div className="row g-4 mt-4">

            {/* Call */}
            <div className="col-lg-4 col-md-6">
              <div className="contact_card">
                <div className="contact_icon">
                  <i className="fa fa-phone"></i>
                </div>

                <h4>Call Us</h4>

                <a href={`tel:${webSetting.number}`}>
                  {webSetting.number}
                </a>

                <p>9:30 AM - 6:00 PM</p>
              </div>
            </div>

            {/* Complaint */}
            <div className="col-lg-4 col-md-6">
              <div className="contact_card">
                <div className="contact_icon">
                  <i className="fa fa-mobile"></i>
                </div>

                <h4>Complaint</h4>

                <a href={`tel:${webSetting.number}`}>
                  {webSetting.number}
                </a>

                <p>10:00 AM - 6:00 PM</p>
              </div>
            </div>

            {/* Email */}
            <div className="col-lg-4 col-md-6">
              <div className="contact_card">
                <div className="contact_icon">
                  <i className="fa fa-envelope-o"></i>
                </div>

                <h4>Email Us</h4>

                <a href={`mailto:${webSetting.email}`}>
                  {webSetting.email}
                </a>

                <p>24 × 7 Support</p>
              </div>
            </div>

          </div>

        </div>
      </section>

      {/* contact Section Start */}
      <VideoForm
        IframeVideo={webSetting.iframe_video}
        SectionTitle={webSetting.video_form_title}
      />


      {/* contact Section End */}

      <section className="contact_address section_padding section_padding_bottom">
        <div className="container">
          <div className="row">
                        <div class="col-lg-12">
              <div className="services-header text-center mb-5">
                <span className="services-badge">Our Address</span>
                <h2 className="services-title">Our Address</h2>
              </div>
            </div>


            <div className="col-md-4 mb-2">
              <div className="brach_bg_one AddBox_bg1">
                <ul className="list-unstyled">
                  <li>
                    <i className="fa fa-map-marker" aria-hidden="true"></i>
                  </li>

                  <li>
                    <span>{webSetting.address}</span>
                  </li>
                </ul>
              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
}
